import './product_group.scss';

document.addEventListener('mouseover', event => {
  if (event.target.classList.contains('hoverChangeImage')) {
    event.target.src = `${event.target.dataset.image_hover}`;
  }
})

document.addEventListener('mouseout', event => {
  if (event.target.classList.contains('hoverChangeImage')) {
    event.target.src = `${event.target.dataset.image}`;
  }
})
